/** API route map: URLS.Controller.OnboardingBenefitGroup */
export const OnboardingBenefitGroup = {
      Name: 'OnboardingBenefitGroup/',
      GetAll: 'getall',
      Add: 'add',
      Update: 'update',
      Delete: 'delete',
      Status: 'status',
};
